// @ts-nocheck
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-light-svg-icons";
import Button from "@ebsco-ui/button";
import cn from "classnames";

export const CloseButton = ({ closeToast, className, title }) => (
  <Button
    aria-label={title}
    className={cn(className, "toast__close-button")}
    onClick={closeToast}
    styleType="link"
  >
    <FontAwesomeIcon icon={faTimes} size="lg" title={title} />
  </Button>
);

CloseButton.propTypes = {
  closeToast: PropTypes.func,
  title: PropTypes.string,
};
